import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero, SectionHead, Reveal, GoldButton, OutlineButton } from "@/components/bits/Reveal";
import { RECRUITMENT_PROCESS } from "@/data/content";
import { IMAGES } from "@/data/content";
import { useSEO } from "@/lib/seo";

export default function Process() {
  useSEO(
    "How Our Recruitment Process Works | Maqline Solutions Pvt Ltd",
    "From requirement analysis to workforce support — the nine-step recruitment and deployment process Maqline Solutions Pvt Ltd follows for every engagement."
  );

  return (
    <main data-testid="process-page">
      <PageHero
        overline="Recruitment Process"
        titleLines={["How Our Recruitment", "Process Works"]}
        description="Nine disciplined steps between your requirement and a supported, deployed workforce. No black boxes."
        image={IMAGES.engineer}
      />

      <section className="bg-white py-16 sm:py-24">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <div className="relative">
            <div className="absolute left-6 sm:left-8 top-0 bottom-0 w-px bg-gradient-to-b from-gold/70 via-ink/15 to-transparent" />
            <div className="space-y-0">
              {RECRUITMENT_PROCESS.map((s, i) => (
                <Reveal key={s.num} delay={0.04}>
                  <div className="relative flex gap-8 sm:gap-12 pb-14 group" data-testid={`process-step-${s.num}`}>
                    <div className="relative z-10 shrink-0">
                      <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white border-2 border-gold/60 group-hover:border-gold group-hover:bg-gold/10 rounded-sm flex items-center justify-center font-mono text-base sm:text-xl font-bold text-navy transition-all duration-400">
                        {s.num}
                      </div>
                    </div>
                    <div className="pt-1 sm:pt-3">
                      <h3 className="font-display text-2xl sm:text-3xl text-ink group-hover:text-navy transition-colors duration-300 tracking-tight">{s.title}</h3>
                      <p className="text-sm sm:text-base text-muted mt-2 leading-relaxed max-w-2xl">{s.text}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal>
            <div className="mt-8 bg-steel border border-ink/10 rounded-sm p-8 sm:p-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
              <div>
                <h3 className="font-display text-2xl text-ink">Have a requirement ready?</h3>
                <p className="text-sm text-muted mt-1">Step 01 starts with a five-minute form.</p>
              </div>
              <div className="flex gap-3">
                <Link to="/businesses#request" data-testid="process-cta-employer"><GoldButton>Share Requirement</GoldButton></Link>
                <Link to="/careers" data-testid="process-cta-student"><OutlineButton>I'm a Candidate</OutlineButton></Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
